import request from '@/utils/request'

export const commentLikings = (comId) => {
  return request('/v1_0/comment/likings', 'post', { target: comId })
}

export const unCommentLikings = (comId) => {
  return request(`/v1_0/comment/likings/${comId}`, 'delete')
}
